import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d22ce2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-print" }

import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { RepairOrderClosedResource } from '@shared/resources/repair-order';
import { computed } from 'vue';
import { isOrder } from '@shared/types/order-type';
import { usePrint } from '@components/print/use-print';
import PrintInvoiceFull from '@components/print/documents/PrintInvoiceFullNew.vue';
import PrintInvoiceOrder from '@components/print/documents/PrintInvoiceOrderNew.vue';
import PrintInvoiceRepair from '@components/print/documents/PrintInvoiceRepairNew.vue';

interface Props {
  data: RepairOrderClosedResource,
}
enum PrintType {
  INVOICE_FULL = 'INVOICE_FULL', // рахунок
  INVOICE_REPAIR = 'INVOICE_REPAIR', // акт виконаних робіт
  INVOICE_REPAIR_NUMERIC_DATE = 'INVOICE_REPAIR_NUMERIC_DATE', // акт виконаних робіт дата в цифрах
  INVOICE_ORDER = 'INVOICE_ORDER', // накладна
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectPrintNew',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: RepairOrderClosedResource,
}



const { print } = usePrint();

const PrintTypesOptionsMap = {
  [PrintType.INVOICE_FULL]: {
    name: 'Рахунок',
    id: PrintType.INVOICE_FULL,
  },
  [PrintType.INVOICE_REPAIR]: {
    name: 'Акт виконаних робіт',
    id: PrintType.INVOICE_REPAIR,
  },
  [PrintType.INVOICE_REPAIR_NUMERIC_DATE]: {
    name: 'Акт виконаних робіт (числова дата)',
    id: PrintType.INVOICE_REPAIR_NUMERIC_DATE,
  },
  [PrintType.INVOICE_ORDER]: {
    name: 'Накладна',
    id: PrintType.INVOICE_ORDER,
  },
}

const options = computed(() => {
  const { orderType } = props.data;
  let list = [
    PrintTypesOptionsMap[PrintType.INVOICE_FULL],
    PrintTypesOptionsMap[PrintType.INVOICE_REPAIR],
    PrintTypesOptionsMap[PrintType.INVOICE_REPAIR_NUMERIC_DATE],
  ];
  if (isOrder(orderType)) {
    list.push(PrintTypesOptionsMap[PrintType.INVOICE_ORDER]);
  }

  return list;
});

const selectDataManager = useSelectClientDataManager({
  data: options,
});

function choose(type: PrintType) {
  let component;
  let additionalProps: Record<string, any> = {};
  switch(type) {
    case PrintType.INVOICE_FULL: component = PrintInvoiceFull; break;
    case PrintType.INVOICE_ORDER: component = PrintInvoiceOrder; break;
    case PrintType.INVOICE_REPAIR: component = PrintInvoiceRepair; break;
    case PrintType.INVOICE_REPAIR_NUMERIC_DATE:
      component = PrintInvoiceRepair;
      additionalProps = {
        numericDate: true,
      };
      break;
  }

  print({
    component,
    props: {
      order: props.data,
      ...additionalProps,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SingleSelect), {
      class: "w-full",
      "data-manager": _unref(selectDataManager),
      "hide-empty": "",
      "disable-search": "",
      small: "",
      "select-option-text": _ctx.$t('common.select-print'),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (choose($event.id)))
    }, null, 8, ["data-manager", "select-option-text"])
  ]))
}
}

})